import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import LessonOverView from './LessonOverView'
import { withTour } from '../../../../../components/Tour/withTour'

import * as lessonBuilderActions from '../../../../../store/actions/lessonBuilder'

export default withTour(
  connect(
    null,
    (dispatch) => ({
      lessonBuilderActions: bindActionCreators(lessonBuilderActions, dispatch)
    })
  )(LessonOverView)
)
